import { Alert } from '@mui/material';
import { lang } from 'src/utils/language';

import { AlertWrapper } from './ComponentListAlert.styled';

export const ComponentListAlert = ({
  hasDYS,
  hasDYR,
  infoMessage,
}: {
  hasDYS: boolean;
  hasDYR: boolean;
  infoMessage?: string;
}) => {
  return (
    <AlertWrapper>
      {hasDYS && (
        <Alert severity="info">{lang.componentListModal.suggestion}</Alert>
      )}
      {hasDYR && (
        <Alert severity="info">{lang.componentListModal.recommended}</Alert>
      )}
      {!hasDYS && !hasDYR && (
        <Alert severity="info">{infoMessage || lang.componentModalInfo}</Alert>
      )}
    </AlertWrapper>
  );
};
